import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import config from "../../Config";
import StudentRightsCheck from "./StudentRightsCheck";
import StudentPanelMenu from "./StudentPanelMenu";

function StudentPanelEvents() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    document.title = "Events & Calendar - Student Panel";
    const payloads = [
      {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType: MemberType || "Student",
        SchoolID: 1,
        pageNo: 1,
        pageSize: 100,
      },
      {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType: "Student",
        SchoolID: 1,
        pageNo: 1,
        pageSize: 100,
      },
      {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType: "Parent",
        SchoolID: 1,
        pageNo: 1,
        pageSize: 100,
      },
    ];

    const tryLoad = (idx) => {
      if (idx >= payloads.length) {
        setEvents([]);
        toast.error("Could not load events.");
        setLoading(false);
        return;
      }
      axios({
        method: "post",
        url: config.base_url + "SchoolEvent/GetEventsForStudentDashboard",
        headers: { "Content-Type": "application/json" },
        data: payloads[idx],
      })
        .then((res) => {
          if (res.data?.status_code === 1) {
            setEvents(res.data.ListofRecords || []);
            setLoading(false);
          } else {
            tryLoad(idx + 1);
          }
        })
        .catch(() => tryLoad(idx + 1));
    };

    tryLoad(0);
  }, []);

  return (
    <>
      <StudentPanelMenu />
      <ToastContainer />
      <StudentRightsCheck />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/student-panel/dashboard">Dashboard</Link></li>
                    <li className="breadcrumb-item active">Events & Calendar</li>
                  </ol>
                </nav>
                <div className="page-title">Events & Calendar</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container body-content">
        <div className="card">
          <div className="card-body">
            {loading ? (
              <Spinner animation="border" />
            ) : events.length === 0 ? (
              <p className="text-muted mb-0">No approved events available right now.</p>
            ) : (
              <ul className="list-group list-group-flush">
                {events.map((e) => (
                  <li key={e.ID} className="list-group-item px-0">
                    {e.TitleImage ? (
                      <img
                        src={`${config.root}SchoolEvents/${e.TitleImage}`}
                        alt=""
                        className="mb-2"
                        style={{ width: "100%", maxHeight: 220, objectFit: "cover", borderRadius: 8 }}
                      />
                    ) : null}
                    <h6 className="mb-1">{e.EventTitle}</h6>
                    <p className="mb-1 small text-muted">
                      {moment(e.StartDate).format("DD MMM YYYY, hh:mm A")} - {moment(e.EndDate).format("DD MMM YYYY, hh:mm A")}
                    </p>
                    {e.LocationAddress && <p className="mb-1 small">Location: {e.LocationAddress}</p>}
                    {e.EventDetails && <p className="mb-0">{e.EventDetails}</p>}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentPanelEvents;
